import styled from '@emotion/styled';
import { $fontStackPrimary, $fontWeightBold } from '@src/variables';

const DrawerHeader = styled.header({
  alignItems: 'center',
  background: '#ffffff',
  borderBottom: '1px solid #e9ebed',
  display: 'flex',
  fontFamily: $fontStackPrimary,
  fontSize: '1.6rem',
  fontWeight: $fontWeightBold,
  padding: '1.8rem 2.5rem 1.8rem 2.2rem'
});

export default DrawerHeader;
